import React from 'react';
import styled from 'styled-components';
import * as theme from '../../theme';

const Wrapper = styled.div`
    border-radius: 5px;
    border: ${props => props.selected ? '2px solid var(--focus-color)' : '2px solid var(--primary-color)'};
`

const Container = styled.div`
    background-color: ${props => props.theme === 'Dark' ? theme.dark['--primary-color'] : theme.light['--primary-color']};
    border: ${props => props.theme === 'Dark' ? '1px solid ' + theme.dark['--secondary-color'] : '1px solid ' + theme.light['--secondary-color']};
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    cursor: pointer;
`

const Header = styled.div`
    background-color: ${props => props.theme === 'Dark' ? theme.dark['--secondary-color'] : theme.light['--secondary-color']};
    border-radius: 5px 5px 0 0;
    color: ${props => props.theme === 'Dark' ? theme.dark['--text-color'] : theme.light['--text-color']};;
    font-weight: bolder;
    padding: 0.5rem;
    // width: 100%;
`

const Body = styled.div`
    padding: 0.5rem;
    display: flex;
    flex-direction: column;
`

const ItemContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 1rem;
    width: 100%;
    margin: 0.5rem 0 0.5rem 0;
`

const Item = styled.div`
    flex-grow: 4;
    margin: 0 0.5rem 0 0.5rem;
    border-radius: 5px;
    height: 1rem;
    background-color: ${props => props.theme === 'Dark' ? theme.dark['--secondary-color'] : theme.light['--secondary-color']};
`

const Circle = styled.div`
    border: ${props => props.theme === 'Dark' ? '2px solid ' + theme.dark['--secondary-color'] : '2px solid ' + theme.light['--secondary-color']};
    border-radius: 50%;
    background-color: transparent;
    width: 0.75rem;
    height: 0.75rem;
`

const Button = styled.div`
    background-color: var(--focus-color);
    width: 2rem;
    border-radius: 5px;
    height: 1rem;
`

const Selected = styled.div`
    display: flex;
    justify-content: center;
    padding: 0.3rem;
    font-weight: bolder;
`

const ThemeOption = props => {
    const {
        theme,
        onSelect,
        selected,
    } = props;

    return (
        <Wrapper selected={selected}>
            <Container theme={theme} onClick={onSelect}>
                <Header theme={theme}>{theme}</Header>
                <Body>
                    <ItemContainer theme={theme}>
                        <Circle theme={theme}/>
                        <Item theme={theme}/>
                    </ItemContainer>

                    <ItemContainer theme={theme}>
                        <Circle theme={theme}/>
                        <Item theme={theme}/>
                    </ItemContainer>
                    <Button/>
                </Body>
            </Container>
        </Wrapper>
        
    )
}

export default ThemeOption
